/* global attachEvent, VideoPlayer */
// *******************************************************************************
// 1.0 - Open Video modal
// *******************************************************************************

attachEvent('[data-videomodal]', 'click', (ev) => {
  const parentElem = ev.target.closest('.video-card');
  const videoModal = parentElem.querySelector('.video-modal');
  videoModal.classList.add('is-open-video-modal');
  VideoPlayer(parentElem);
});
